import { Button } from "@svea/design-system-components-react";
import { Checkbox, FormControlLabel, Stack } from "@sveabank/cc-common";
import Card from "../card";

type Props = {
	checked: boolean;
	disabled?: boolean;
	editable?: boolean;
	onChange: () => void;
	onRemove?: () => void;
	children: React.ReactNode;
};

const CheckboxCard = ({
	checked,
	onChange,
	onRemove,
	disabled,
	editable = true,
	children,
}: Props) => (
	<Card classNames="bg-background-secondary">
		{!editable ? (
			children
		) : (
			<Stack gap={2} direction="row">
				<FormControlLabel label={children} gap={4}>
					<Checkbox checked={checked} onChange={onChange} disabled={disabled} />
				</FormControlLabel>
				{onRemove && <Button variant="icon" onPress={onRemove} icon="trash" aria-label="Ta bort" />}
			</Stack>
		)}
	</Card>
);

export default CheckboxCard;
